'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_common_BuildInfo$() {
  this.amf = null;
  this.a6B = null;
  this.amh = null;
  this.amg = null;
  this.ami = null;
  $n_Lmealorama_common_BuildInfo$ = this;
  this.amf = "meal-o-rama-common";
  this.a6B = "3.0.15";
  this.amh = "3.9.0";
  this.amg = "2.0.8";
  this.ami = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_StringOps$().vy("name: %s, version: %s, scalaVersion: %s, sbtVersion: %s", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().cr(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([this.amf, this.a6B, this.amh, this.amg])));
}
export { $c_Lmealorama_common_BuildInfo$ as $c_Lmealorama_common_BuildInfo$ };
$p = $c_Lmealorama_common_BuildInfo$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_common_BuildInfo$;
/** @constructor */
function $h_Lmealorama_common_BuildInfo$() {
}
export { $h_Lmealorama_common_BuildInfo$ as $h_Lmealorama_common_BuildInfo$ };
$h_Lmealorama_common_BuildInfo$.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return 602658844;
});
$p.q = (function() {
  return 0;
});
$p.r = (function() {
  return "BuildInfo";
});
$p.g = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
$p.m = (function() {
  return this.ami;
});
var $d_Lmealorama_common_BuildInfo$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_common_BuildInfo$, "mealorama.common.BuildInfo$", ({
  Hh: 1,
  b: 1,
  c: 1,
  a: 1,
  d: 1,
  e: 1,
  h: 1
}));
export { $d_Lmealorama_common_BuildInfo$ as $d_Lmealorama_common_BuildInfo$ };
var $n_Lmealorama_common_BuildInfo$;
function $m_Lmealorama_common_BuildInfo$() {
  if ((!$n_Lmealorama_common_BuildInfo$)) {
    $n_Lmealorama_common_BuildInfo$ = new $c_Lmealorama_common_BuildInfo$();
  }
  return $n_Lmealorama_common_BuildInfo$;
}
export { $m_Lmealorama_common_BuildInfo$ as $m_Lmealorama_common_BuildInfo$ };
//# sourceMappingURL=mealorama.common.-Build-Info$.js.map
